import { useState, useEffect, PropsWithChildren } from 'react';
import { LoadingOverlay, Box } from '@mantine/core';
// import { useAppSelector } from '@/shared';
// import { selectIsAuth } from '@/modules/auth';
import { useGetUserInfoQuery } from '@/modules/profile';
import { useGetCurrenciesQuery, useGetUserRolesQuery } from '@/shared';
import { useGetWithdrawalsAwaitingApprovalQuery } from '@/modules/withdrawals';
import { useGetPaymentsAwaitingApprovalQuery } from '@/modules/payments';

export const AppLoader = ({ children }: PropsWithChildren) => {
  const [isAppLoaded, setIsAppLoaded] = useState(false);
  const { isLoading: isUserInfoLoading } = useGetUserInfoQuery();
  const { isLoading: isUserRolesLoading } = useGetUserRolesQuery();
  const { isLoading: isCurrenciesLoading } = useGetCurrenciesQuery();
  const { isLoading: isPaymentsLoading } = useGetPaymentsAwaitingApprovalQuery(undefined, {
    pollingInterval: 60000,
  });
  const { isLoading: isWithdrawalsLoading } = useGetWithdrawalsAwaitingApprovalQuery();
  // const isAuth = useAppSelector(selectIsAuth);

  const isLoading = isCurrenciesLoading
    || isUserInfoLoading
    || isUserRolesLoading
    || isWithdrawalsLoading
    || isPaymentsLoading;

  useEffect(() => {
    if (!isLoading) {
      setIsAppLoaded(true);
    }
  }, [isLoading]);

  if (!isAppLoaded) {
    return (
      <Box pos="relative">
        <LoadingOverlay visible={true} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
      </Box>
    );
  }

  return children;
};
